// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"6c13ece3","744":"ccf95ffe"}[chunkId] + ".chunk.js";
};